<template>
  <router-link
    v-if="routerLink"
    :to="routerLink"
    class="action"
    :class="classObject"
    :exact="exact"
    @click="onClick"
  >
    <span class="action__inner">
      <slot />
    </span>
  </router-link>

  <a
    v-else
    :href="href"
    class="action"
    :class="classObject"
    @click="onClick"
  >
    <span class="action__inner">
      <slot />
    </span>
  </a>
</template>

<script>
import action from './action.vue'

export default {
  name: 'CActionLink',

  extends: action,

  props: {
    href: {
      type: String,
      default: undefined
    },
    routerLink: {
      type: [String, Object],
      default: undefined
    },
    exact: Boolean
  }
}
</script>
